/**
 * What's new (`/whats-new`, and `/whats-new/:version` for a chosen release), under Support.
 *
 * The head is generic; the body is the shared list and detail layout (ReleaseBrowser). The running
 * version and its deploy time come from the existing `/api/version` query (the bundled version until
 * it answers); the notes ship inside the bundle and the change log never reaches the page.
 */

import { useVersion } from '@/api/queries';
import { PageHead } from '@/ui/PageHead';

import { ReleaseBrowser } from './ReleaseBrowser';
import { RELEASES, loadBody } from './releaseIndex';

export function WhatsNewPage() {
  const running = useVersion().data;
  return (
    <>
      <PageHead title="What's new" subtitle="Release notes for Wynxx Discover" />
      <ReleaseBrowser
        releases={RELEASES}
        runningVersion={running?.version ?? __APP_VERSION__}
        deployedAt={running?.deployed_at}
        loadBody={loadBody}
      />
    </>
  );
}
